import { render, staticRenderFns } from "./DetailedPostCost.vue?vue&type=template&id=46674fee&scoped=true&"
import script from "./DetailedPostCost.vue?vue&type=script&lang=js&"
export * from "./DetailedPostCost.vue?vue&type=script&lang=js&"
import style0 from "./DetailedPostCost.vue?vue&type=style&index=0&id=46674fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46674fee",
  null
  
)

export default component.exports